import { BasicResult } from "../../basic-result";
import { AuditResultFilters } from "./audit-result-filters";

export class ResultFiltersReturn extends BasicResult {
    public Filters: AuditResultFilters = new AuditResultFilters();
    constructor(values: Object = {}) {
        super();
        Object.assign(this, values);
    }

}